import { __extends } from "tslib";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { usePromiseCallback } from '../../mixins';
import { destroyElem, destroyElemByKey, type } from '../../utils';
import { CreateInstance, PREFIX_KEY, LeaveClass } from './instance';
var DEFAULTS = {
    top: 24,
    duration: 3
};
var Message = /** @class */ (function (_super) {
    __extends(Message, _super);
    function Message() {
        var _this = _super.call(this) || this;
        _this.VERSION = '2.0';
        setTimeout(function () { return _this._init(DEFAULTS.top); }, 0);
        return _this;
    }
    Message.prototype.info = function (config) {
        this._create('info', config, DEFAULTS.duration);
        return usePromiseCallback(DEFAULTS.duration, config);
    };
    Message.prototype.success = function (config) {
        this._create('success', config, DEFAULTS.duration);
        return usePromiseCallback(DEFAULTS.duration, config);
    };
    Message.prototype.warning = function (config) {
        this._create('warning', config, DEFAULTS.duration);
        return usePromiseCallback(DEFAULTS.duration, config);
    };
    Message.prototype.error = function (config) {
        this._create('error', config, DEFAULTS.duration);
        return usePromiseCallback(DEFAULTS.duration, config);
    };
    Message.prototype.loading = function (config) {
        this._create('loading', config, DEFAULTS.duration);
        return usePromiseCallback(DEFAULTS.duration, config);
    };
    Message.prototype.config = function (options) {
        if (options.top && type.isNum(options.top)) {
            DEFAULTS.top = options.top;
        }
        if ((options.duration && type.isNum(options.duration)) || options.duration === 0) {
            DEFAULTS.duration = options.duration;
        }
    };
    Message.prototype.destroy = function (key) {
        if (key && (type.isStr(key) || type.isNum(key))) {
            destroyElemByKey({
                key: key,
                duration: 0.1,
                prefixKey: PREFIX_KEY,
                clsLeave: LeaveClass
            });
        }
        else {
            this.INSTANCES.forEach(function (instance) {
                destroyElem(instance, {
                    duration: 0.1,
                    clsLeave: LeaveClass
                });
            });
            this.INSTANCES.length = 0;
        }
    };
    return Message;
}(CreateInstance));
export default Message;
